// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default (theme: any) => ({
    gridItemContent: {
        marginTop: '5px',
        marginBottom: '10px',
        caretColor: theme.palette.primary.main,
        '& .MuiInputBase-input': {
            height: 'unset',
            fontSize: '1rem',
        },
    },
    input: {
        fontSize: '12px',
        color: 'black',
        fontWeight: 'bold',
    },
    inputError: {
        '&::placeholder': {
            color: 'red !important',
        },
    },
    item: {
        margin: '0px 4px',
        padding: '8px 16px',
        '&:hover': {
            backgroundColor: 'rgba(49, 51, 54, 0.04)'
        }
    },
    option: {
        margin: '0 4px',
        backgroundColor: theme.palette.lightGrey.ultraLight,
        borderBottom: `1px solid ${theme.palette.lightGrey.half}`,
    },
    optionSubHeader: {
        borderBottom: `1px solid ${theme.palette.lightGrey.mediumDark}`,
        fontWeight: 600,
        color: theme.palette.typography.medium,
    },
    optionMainInfo: {
        lineHeight: '24px',
        fontSize: '16px',
        fontWeight: 600
    },
    optionAdditionalInfo: { 
        fontSize: '14px', 
        fontWeight: 400, 
        color: theme.palette.typography.half, 
        lineHeight: '20px' 
    }
})
